(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('.f9-brand-menu').forEach(menu => {
      if (menu.dataset.ready) return;
      menu.dataset.ready = 'true';
      const opener = menu.querySelector('[data-f9-menu-open]');
      const dialog = menu.querySelector('dialog');
      const closer = menu.querySelector('[data-f9-menu-close]');
      if (!opener || !dialog || !closer) return;
      let previousOverflow = '';
      opener.addEventListener('click', () => { previousOverflow = document.documentElement.style.overflow; dialog.showModal(); opener.setAttribute('aria-expanded', 'true'); document.documentElement.style.overflow = 'hidden'; closer.focus(); });
      closer.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target !== dialog) return; const bounds = dialog.getBoundingClientRect(); if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close(); });
      dialog.addEventListener('close', () => { opener.setAttribute('aria-expanded', 'false'); document.documentElement.style.overflow = previousOverflow; opener.focus(); });
      dialog.querySelectorAll('a').forEach(link => link.addEventListener('click', () => dialog.close()));
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
